// The evolving illustration of one facility tier, with the upgrade reveal
// animation and a graceful placeholder. Shared by the campus FacilityCard
// and the visual building/court management cards so the "advance = visual
// upgrade" feel is identical everywhere. Exterior facilities (courts) try
// the region variant first.

import type { CSSProperties } from 'react'
import type { LucideIcon } from 'lucide-react'
import { useGameStore } from '@/store/gameStore'
import { FacilityVisual, getFacilityAsset, facilityAssetCandidates } from '@/config/campusConfig'
import { TierRevealClip } from './TierRevealClip'
import { FacilityPlaceholder } from './FacilityPlaceholder'
import { AssetImage } from './AssetImage'

export function FacilityTierImage({ visual, tier, icon, className = 'facility-img tx-glass-sheen', style }: {
  visual: FacilityVisual
  tier: number
  icon: LucideIcon
  className?: string
  style?: CSSProperties
}) {
  const region = useGameStore(s => s.region)
  const asset = getFacilityAsset(visual, tier)
  const notBuilt = tier < 0

  return (
    <div className={className} style={style}>
      {notBuilt ? (
        <FacilityPlaceholder gradient={['#10192a', '#1c2940']} icon={icon} caption="Sin construir" />
      ) : (
        <TierRevealClip tierKey={tier}>
          {asset ? (
            <AssetImage
              sources={facilityAssetCandidates(visual, asset, region)}
              alt={`${visual.name}: ${asset.caption}`}
              fallback={
                <FacilityPlaceholder gradient={visual.placeholderGradient} icon={icon} caption={asset.caption} />
              }
            />
          ) : (
            <FacilityPlaceholder gradient={visual.placeholderGradient} icon={icon} />
          )}
        </TierRevealClip>
      )}
    </div>
  )
}
